import { render, staticRenderFns } from "./Writeoffs.vue?vue&type=template&id=5a971510&"
import script from "./Writeoffs.vue?vue&type=script&lang=js&"
export * from "./Writeoffs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Writeoffs.vue"
export default component.exports